import { useEffect, useState } from "react";

const useAuthPermissions = () => {
  const [permission, setPermission] = useState([]);
  const [role, setRole] = useState("");

  const loadAuth = () => {
    const perms = localStorage.getItem("userPermissions");
    const realRole = localStorage.getItem("role");

    setPermission(perms ? JSON.parse(perms) : []);
    setRole(realRole || "");
  };

  useEffect(() => {
    loadAuth();

    window.addEventListener("authUpdated", loadAuth);
    window.addEventListener("storage", loadAuth);

    return () => {
      window.removeEventListener("authUpdated", loadAuth);
      window.removeEventListener("storage", loadAuth);
    };
  }, []);

  return { permission, role };
};

export default useAuthPermissions;










// import { useEffect, useState } from "react";

// const useAuthPermissions = () => {
//   const [permission, setPermission] = useState(null);
//   const [role, setRole] = useState(null);

//   useEffect(() => {
//     const perms = localStorage.getItem("userPermissions");
//     const role = localStorage.getItem("role");

//     if (perms && role) {
//       setPermission(JSON.parse(perms));
//       setRole(role);
//     }
//   }, []);

//   return { permission, role };
// };

// export default useAuthPermissions;
